
import * as axios from "axios";

export const GET_SETTINGS_START = 'GET_SETTINGS_START';
export const GET_SETTINGS = 'GET_SETTINGS';

export const getSettings = (email) => dispatch => {
    dispatch({type: GET_SETTINGS_START});
    const payload = axios.get('/api/settings/' + email);
    dispatch({
        type: GET_SETTINGS,
        payload
    });
};

export const UPDATE_SETTINGS_START = 'UPDATE_SETTINGS_START';
export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';

export const updateSettings = (props) => dispatch => {
    dispatch({type: UPDATE_SETTINGS_START});
    const payload = axios.post('/api/settingssubscribe', props);
    dispatch({
        type: UPDATE_SETTINGS,
        payload
    });
}


// WEBPACK FOOTER //
// ./src/containers/settings/SettingsActions.js